import { API_ROUTES, apiPost } from '@configure/apiConfig';

export const fetchPeopleData = async ({ type, pageSize, toggleView }) => {
  const response = await apiPost(
    API_ROUTES.GET_PEOPLE_RM,
    {
      tabType: type || 'all_resources',
      pageNumber: 1,
      pageSize: 10000,
      sortColumn: '',
      sortType: '',
      columnSearchFilter: '',
      columnSearchFilterValue: '',
      filterParams: {},
    },
    'get-people-data'
  );
  return response;
};


